import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const ticketsCheck = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 100
        },
        {
            title: '申请退票原因',
            dataIndex: 'refundReason',
            key: 'refundReason',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.refundReason || [],
        },
        {
            title: '退票创建人',
            dataIndex: 'refundPersonName',
            key: 'refundPersonName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.refundPersonName || [],
        },
        {
            title: '退票申请时间',
            dataIndex: 'refundTime',
            key: 'refundTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '合同编号',
            dataIndex: 'contractNumbers',
            key: 'contractNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contractNumbers'
            },
            filteredValue: filteredInfo.contractNumber || [],
        },
        {
            title: '发票号码',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoiceNumber || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '发票金额',
            dataIndex: 'invoiceAmount',
            key: 'invoiceAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoiceAmount || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '发票内容',
            dataIndex: 'invoiceContent',
            key: 'invoiceContent',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoiceContent || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '发票类型',
            dataIndex: 'invoiceType',
            key: 'invoiceType',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoiceType|| [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '开票日期',
            dataIndex: 'invoiceDate',
            key: 'invoiceDate',
        },
        {
            title: '是否可连号',
            dataIndex: 'connectedFlag',
            key: 'connectedFlag',
            scopedSlots: {
                customRender: 'connectedFlag'
            }
        },
        {
            title: '是否同一天',
            dataIndex: 'sameDayFlag',
            key: 'sameDayFlag',
            scopedSlots: {
                customRender: 'sameDayFlag'
            }
        },
        {
            title: '合同发票总数',
            dataIndex: 'requestNumberOfInvoices',
            key: 'requestNumberOfInvoices'
        },
        {
            title: '开票单位',
            dataIndex: 'billingUnit.companyName',
            key: 'billingUnitName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.billingUnitName || [],
        },
        {
            title: '发票状态',
            dataIndex: 'invoiceStatus',
            key: 'invoiceStatus',
            scopedSlots: {
                filterDropdown: 'filterInvoice',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'invoiceStatus'
            },
            filteredValue: filteredInfo.invoiceStatus || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '发票抬头',
            dataIndex: 'invoiceTitle',
            key: 'invoiceTitle',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
        },
        {
            title: '销售',
            dataIndex: 'sale.name',
            key: 'saleName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.saleName || [],
        },
        {
            title: '客户',
            dataIndex: 'contactName',
            key: 'contactName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contactName'
            },
            filteredValue: filteredInfo.contactName || [],
        },
        {
            title: '负责人',
            dataIndex: 'invoicingPrincipal.name',
            key: 'invoicingPrincipal',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoicingPrincipal || [],
        },
        {
            title: '发票创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },

        {
            title: '退票状态',
            dataIndex: 'refundAuditStatus',
            key: 'refundAuditStatus',
            scopedSlots: {
                filterDropdown: 'filterStatus',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'refundAuditStatus'
            },
            filteredValue: filteredInfo.refundAuditStatus || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '退票日期',
            dataIndex: 'refundDate',
            key: 'refundDate',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '审核人员',
            dataIndex: 'operatingPersonName',
            key: 'operatingPersonName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.operatingPersonName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '退票审核时间',
            dataIndex: 'operatingTime',
            key: 'operatingTime',
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.remark || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
